module.exports = __webpack_public_path__ + "img/14_bohle.297a7173.jpeg";